module.exports = __webpack_public_path__ + "img/c05_unitdecurion_Normal_ua.e779a84a.webp";